//jshint esversion:8
import Store from "./store/Store";
import MainPage from "./MainPage/MainPage";
const App = () => {
  return <MainPage />;
};

export default App;